import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './zh-CN'
import zhTW from './zh-TW'
import en from './en'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(VueI18n)

const messages = {
  'en': {
    ...en,
    ...enLocale
  },
  'zh-CN': {
    ...zhCN,
    ...zhCNLocale
  },
  'zh-TW': {
    ...zhTW,
    ...zhTWLocale
  }
}

// 获取浏览器语言设置
const navLang = navigator.language
const localLang = (navLang === 'zh-CN' || navLang === 'zh-TW') ? navLang : 'zh-CN'

// 从localStorage中获取用户上次选择的语言
const langInLocalStorage = localStorage.getItem('lang')
const lang = langInLocalStorage || localLang

// 创建i18n实例
const i18n = new VueI18n({
  locale: lang,
  messages
})

// 设置element-ui的语言
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n 